"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganisationStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.OrganisationStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    email: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    phone: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    imageStoragePath: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    streetAddress: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    postalCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    city: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    country: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    vatId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    industry: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    createdAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
    referralCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    stripeCustomerId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    imageFile: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    // Member ids who are points of contact for this organisation.
    // Empty/absent ⇒ UI falls back to the most recently created admin.
    pocUserIds: (0, superstruct_1.optional)((0, superstruct_1.array)((0, superstruct_1.string)())),
});
exports.OrganisationStruct.type = 'Organisation';
//# sourceMappingURL=organisation.js.map